import { render, staticRenderFns } from "./ModalImageProfile.vue?vue&type=template&id=1ad1042a"
import script from "./ModalImageProfile.vue?vue&type=script&lang=ts"
export * from "./ModalImageProfile.vue?vue&type=script&lang=ts"
import style0 from "./ModalImageProfile.vue?vue&type=style&index=0&id=1ad1042a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports